import { Box } from '@mui/material'
import React from 'react'

import AnalyzeMenu from './LegacyAnalyzeMenu'
import AssessmentMenu from './LegacyAssessmentMenu'
import CO2eCalculatorLink from './LegacyCO2eCalculatorLink'
import DashboardLink from './LegacyDashboardLink'
import ExpectationsLink from './LegacyExpectationsLink'
import ProductsMenu from './LegacyProductsMenu'
import ProviderMenu from './LegacyProviderMenu'
import RecommendedJourneyLink from './LegacyRecommendedJourneyLink'
import RequestMenu from './LegacyRequestMenu'
import SubscriptionLink from './LegacySubscriptionLink'
import SustainabilityProfileLink from './LegacySustainabilityProfileLink'
import SustainabilityReportMenu from './LegacySustainabilityReportMenu'
import TransparencyProductMenu from './LegacyTransparencyProductMenu'

interface NavbarItemsProps {
  flexDirection?: 'row' | 'column'
  closeMenuDrawer?: () => void
}

export type NavbarItemProps = Pick<NavbarItemsProps, 'closeMenuDrawer'>

const NavbarItems = ({ flexDirection = 'row', closeMenuDrawer }: NavbarItemsProps): JSX.Element => (
  <Box height="100%" width="100%" display="flex" flexDirection={flexDirection}>
    <DashboardLink closeMenuDrawer={closeMenuDrawer} />
    <ProviderMenu closeMenuDrawer={closeMenuDrawer} />
    <RecommendedJourneyLink closeMenuDrawer={closeMenuDrawer} />
    <AssessmentMenu closeMenuDrawer={closeMenuDrawer} />
    <RequestMenu closeMenuDrawer={closeMenuDrawer} />
    <ExpectationsLink closeMenuDrawer={closeMenuDrawer} />
    <AnalyzeMenu closeMenuDrawer={closeMenuDrawer} />
    <ProductsMenu closeMenuDrawer={closeMenuDrawer} />
    <SustainabilityReportMenu closeMenuDrawer={closeMenuDrawer} />
    <SubscriptionLink closeMenuDrawer={closeMenuDrawer} />
    <TransparencyProductMenu closeMenuDrawer={closeMenuDrawer} />
    <SustainabilityProfileLink closeMenuDrawer={closeMenuDrawer} />
    <CO2eCalculatorLink closeMenuDrawer={closeMenuDrawer} />
  </Box>
)

export default NavbarItems
